import { render } from "./CandleFormStep5.vue?vue&type=template&id=34504260&scoped=true&lang=html"
import script from "./CandleFormStep5.vue?vue&type=script&lang=js"
export * from "./CandleFormStep5.vue?vue&type=script&lang=js"

import "./CandleFormStep5.vue?vue&type=style&index=0&id=34504260&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34504260"]])

export default __exports__